import {on} from "../util";

declare var mutation_date : string;

let date : Date;

export default class {
    static init = () => {
        init_date();
        controls();
    }
}

function init_date() {
    if(typeof mutation_date !== 'undefined') {
        date = new Date(mutation_date + ' 12:00:00');
    } else {
        date = new Date();
    }
}

function controls() {
    let form = document.getElementById('frm-mutations') as HTMLFormElement;
    if(!form) {
        return;
    }

    on('click', '.js-mutation-prev', () => {
        date.setDate(date.getDate() - 7);
        goto();
    });

    on('click', '.js-mutation-next', () => {
        date.setDate(date.getDate() + 7);
        goto();
    });

    function goto() {
        window.location.href = '/nw/mutations/' + date.toISOString().slice(0,10);
    }
}
